import { createRouter, createWebHistory } from 'vue-router'
import Body from '../components/body.vue'

const routes = [
  {
    path: '/',
    component: Body,
    children: [
      {
        path: '/',
        name: 'HomePage',
        component: () => import('@/pages/home.vue'),
        meta: { title: 'Vectolabs' }
      },
      {
        path: '/smart-city-solution',
        name: 'SmartCitySolution',
        component: () => import('@/pages/smart-city-solution.vue'),
        meta: { title: 'Smart City Solution | Vectolabs' }
      },
      {
        path: '/ai-lintas',
        name: 'AiLintas',
        component: () => import('@/pages/smartcity.vue'),
        meta: { title: 'AI-Lintas Traffic AI | Vectolabs' }
      },
      {
        path: '/organizational-chart',
        name: 'OrganizationalChart',
        component: () => import('@/pages/organizationalchart.vue'),
        meta: { title: 'Organizational Chart | Vectolabs' }
      },
      {
        path: '/hse-statement',
        name: 'HseStatement',
        component: () => import('@/pages/hse.vue'),
        meta: { title: 'HSE Statement | Vectolabs' }
      },
      {
        path: '/company-activities',
        name: 'CompanyActivities',
        component: () => import('@/pages/company-activities.vue'),
        meta: { title: 'Company Activities | Vectolabs' }
      },
      {
        path: '/contact-us',
        name: 'ContactUs',
        component: () => import('@/pages/contact-us.vue'),
        meta: { title: 'Contact Us | Vectolabs' }
      },
      {
        path: '/pdpp',
        name: 'Pdpp',
        component: () => import('@/pages/pdpp.vue'),
        meta: { title: 'Personal Data Protection Policy | Vectolabs' }
      },
      {
        path: '/enterprise-iot-solutions',
        name: 'EnterpriseIot',
        component: () => import('@/pages/enterprise-iot.vue'),
        meta: { title: 'Enterprise IoT Solutions | Vectolabs' }
      },
      {
        path: '/speed-radar',
        name: 'SpeedRadar',
        component: () => import('@/pages/speed-radar.vue'),
        meta: { title: 'Speed Radar | Vectolabs' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  document.title = to.meta?.title || 'Vectolabs'
})

export default router
